import { render, staticRenderFns } from "./MetricasApp.vue?vue&type=template&id=59b1e855&"
import script from "./MetricasApp.vue?vue&type=script&lang=js&"
export * from "./MetricasApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports